var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { MandatesColumn } from "./Constant";
import di from "../../../di/serviceLocator";
var DetailMandatesPop = function (props) {
    var _a = __read(useState(), 2), mandateDetails = _a[0], setMandateDetails = _a[1];
    useEffect(function () {
        di.clients
            .getMandateDetails({
            Accode: props.AccCode,
            page: 1,
            pageSize: 50,
        })
            .then(function (mandate) {
            if ((mandate === null || mandate === void 0 ? void 0 : mandate.length) > 0) {
                setMandateDetails(mandate);
            }
        })
            .catch(function (err) { return console.log(err); });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                    React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                            props.setMandatesShow(false);
                        } }),
                    "Mandate Details-",
                    React.createElement("span", { className: "EncodeSans_20_700" },
                        props.dpname,
                        ", Accode:",
                        props.AccCode)))),
        React.createElement(GenericTable, { columns: MandatesColumn, data: mandateDetails, parentClassName: "salestableParentClass table-responsive mandatestable scrollbar-table-responsive", tableClassName: "salestableclass" })));
};
export default DetailMandatesPop;
